import { render, staticRenderFns } from "./CampaignPageTable.vue?vue&type=template&id=5aedcafa"
import script from "./CampaignPageTable.vue?vue&type=script&lang=js"
export * from "./CampaignPageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports